import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';

const ACTIVE_OPTIONS = [
  { value: null, label: 'All' },
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' },
];

const ActiveSelect = ({ className, ...props }) =>
  <ReactSelect
    className={cx(reactSelectStyles, className)}
    label="Active Status"
    name="active"
    placeholder="Show All"
    options={ACTIVE_OPTIONS}
    onChange={this.handleActive}
    simpleValue
    {...props}
  />;

ActiveSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
  className: PropTypes.string,
};

export default ActiveSelect;



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/ActiveSelect/index.jsx